/**
 * The current legal-document version. Bump whenever Terms / Privacy Policy /
 * Community Guidelines change materially — the app then re-prompts any user whose
 * stored acceptance is older (see `apps/api/src/routes/auth.ts` `needsTermsReaccept`
 * and `apps/web/src/routes/onboarding/reaccept.tsx`).
 *
 * Format: ISO date of the change.
 */
export const TERMS_VERSION = '2026-08-31';
